import { combineReducers } from 'redux';
import loading  from '../../component/containers/loader/LoaderReducer'
import employeeDiscountForm from '../../component/Screens/employeeDiscount/employeeDiscountForm/employeeDiscountFormReducer';
import serviceError from '../../common/ServiceError/ServiceErrorReducer'
import accessDetails from './accessDetailsReducer';



const rootReducer = combineReducers ({
    loading:loading,   
    edFormData:employeeDiscountForm,
    serviceError:serviceError,
    accessDetails: accessDetails
});
export default rootReducer;